/**
 * We really only want a single tracking event for enterprises, and everything else happens with properties, like "action"
 */
export const trackingEventEnterprises = "enterprises";
/**
 * These are the valid actions for the trackingEventEnterprises event
 *
 * Use e.g. keyof typeof trackingEventActionsForEnterprises when typing against this
 */
export const trackingEventActionsForEnterprises = {
    loadProfile: "loadProfile",
    // loadProfileDocuments: "loadProfileDocuments",
    // loadProfileMembers: "loadProfileMembers",
    // loadProfileSettings: "loadProfileSettings",
    // clickProfileNewProjectButton: "clickProfileNewProjectButton",
    // addMembers: "addMembers",
    // memberRemoved: "memberRemoved",
    // memberUpdated: "memberUpdated",
    // memberRoleChange: "memberRoleChange",
};
//# sourceMappingURL=enterprises.js.map